import { render } from "./helpCard.vue?vue&type=template&id=4e6d9f0b&scoped=true"
const script = {}

import "./helpCard.vue?vue&type=style&index=0&id=4e6d9f0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6d9f0b"]])

export default __exports__